import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataService } from 'src/app/services/data.service';
import { CustomPopupComponent } from '../custom-popup/custom-popup.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-son-popup',
  templateUrl: './add-son-popup.component.html',
  styleUrls: ['./add-son-popup.component.sass']
})
export class AddSonPopupComponent implements OnInit {

  public data: any;
  public selfRef: any;

  idForm: FormGroup

  constructor(
    @Optional() private _dialogRef: MatDialogRef<AddSonPopupComponent>,
    @Optional() private _sheetRef: MatBottomSheetRef<AddSonPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public sheetData: any,
    private formBuilder: FormBuilder,
    public dataService: DataService,
    private translate: TranslateService,
    private snackbar: MatSnackBar
  ) {
    this.selfRef = _dialogRef ? _dialogRef : _sheetRef
  }

  ngOnInit(): void {

    this.idForm = this.formBuilder.group({
        id: new FormControl('', Validators.required)
      })
  }

  public addSon() {
    let params = {
      'id': this.idForm.controls['id'].value
    }

    let sub = this.dataService.addSon(params).subscribe((res) => {
        if(res == 'success') {
          this.close(true)
        }
        else {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.add_son_failed'), duration: 4000, panelClass: "error-snackbar" })
        }

      sub.unsubscribe()
    })
  }


  public close(action: boolean) {
    if(action) {
      try { this.selfRef.close(true) } catch { this.selfRef.dismiss(true) }
    }
    else {
      try { this.selfRef.close(false) } catch { this.selfRef.dismiss(false) }
    }

  }

}
